export default {
  wheelChair: [ 'wheelchair_no', 'wheelchair_half', 'wheelchair' ],
  carPark: [ null, 'park' ],
  visuallyImpaired: [ null, 'eye' ],
  hearingImpaired: [ null, 'ear' ],
  locked: [ null, 'lock' ],
  valetParking: [null, 'valet-parking'],
};
